export default function OneStopSection() {
  const services = [
    {
      icon: 'ri-search-eye-line',
      title: '買取査定',
      description: '古物商歴10年の鑑定士が、一点一点に込められた思い出を尊重し、丁寧に拝見いたします。骨董品や着物はもちろん、日常の品々の中に眠る真の価値を見極め、次の方へとつなぐ適正価格をご提示します。',
      color: 'from-[#00A58E] to-[#00C9A7]',
      detail: '熟練の鑑定士が、お品物の『背景』まで含めて評価します。'
    },
    {
      icon: 'ri-delete-bin-line',
      title: '家財整理',
      description: 'お買取りが難しいお品物についても、ご遺族やご本人様に代わり、責任を持って適切に整理・搬出いたします。大型の家具や家電の運び出しもすべてお任せください。ご家族の手を止めることなく、お部屋をスッキリと整えます。',
      color: 'from-[#FF6B35] to-[#F7931E]',
      detail: '丁寧な仕分けから運搬まで、プロが迅速に対応します。'
    },
    {
      icon: 'ri-brush-line',
      title: '簡易清掃',
      description: '家財の搬出後には、まごころを込めて清掃を承ります。次の入居者様や、新たな活用を控えるご家族のために、清々しい状態でお引き渡しいたします。建物への敬意を持って、隅々まで丁寧に仕上げます。',
      color: 'from-[#7CB342] to-[#689F38]',
      detail: '心を込めた清掃で、空間に新たな息吹を吹き込みます。'
    }
  ];

  return (
    <section className="py-32 bg-gradient-to-b from-white to-[#FAF8F3] relative overflow-hidden">
      {/* 和紙テクスチャ背景 */}
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' /%3E%3C/filter%3E%3Crect width='100' height='100' filter='url(%23noise)' opacity='0.05'/%3E%3C/svg%3E")`,
        }}
      ></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* セクションヘッダー */}
        <div className="text-center mb-20">
          <div className="inline-block mb-6">
            <span className="text-[#00A58E] font-bold text-sm tracking-widest uppercase border-b-2 border-[#00A58E] pb-1">
              Total Sport
            </span>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-gray-800 mb-8" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            想いをつなぎ、<br className="md:hidden" />次の一歩を支えるトータルサポート
          </h2>
          <div className="w-32 h-1 bg-gradient-to-r from-transparent via-[#FFD700] to-transparent mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
            ご実家の整理は、ただの片付けではありません。<br />
            それはご家族の歩みを振り返り、大切に整理する時間です。<br />
            飛翠は、買取から家財整理、清掃までをワンストップでお引き受けすることで、<br />
            <strong className="text-[#00A58E]">ご家族が前を向くためのゆとり</strong>を創出いたします。
          </p>
        </div>

        {/* サービスロードマップ */}
        <div className="mb-20">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
            {services.map((service, index) => (
              <div key={index} className="relative">
                {/* サービスカード */}
                <div className="bg-white rounded-3xl p-10 shadow-xl hover:shadow-2xl transition-all duration-500 border border-gray-100 h-full">
                  {/* ステップ番号 */}
                  <div className="absolute -top-4 -left-4 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-[#FFD700] to-[#FFA500] rounded-full shadow-lg">
                    <span className="text-white font-bold text-xl" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                      {index + 1}
                    </span>
                  </div>

                  {/* アイコン */}
                  <div className={`w-24 h-24 flex items-center justify-center bg-gradient-to-br ${service.color} rounded-2xl mb-6 mx-auto`}>
                    <i className={`${service.icon} text-white text-5xl w-12 h-12 flex items-center justify-center`}></i>
                  </div>

                  {/* タイトル */}
                  <h3 className="text-3xl font-bold text-gray-800 text-center mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                    {service.title}
                  </h3>

                  {/* 説明 */}
                  <p className="text-gray-600 leading-relaxed text-center mb-4">
                    {service.description}
                  </p>

                  {/* 詳細 */}
                  <div className="bg-gradient-to-r from-[#00A58E]/5 to-teal-50 border-l-4 border-[#00A58E] px-4 py-3 rounded-r-lg">
                    <p className="text-sm text-gray-700 leading-relaxed">
                      <i className="ri-check-line text-[#00A58E] mr-2"></i>
                      {service.detail}
                    </p>
                  </div>
                </div>

                {/* 矢印アイコン（カード間） */}
                {index < services.length - 1 && (
                  <div className="hidden lg:flex absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                    <div className="w-8 h-8 flex items-center justify-center bg-[#FFD700] rounded-full shadow-lg">
                      <i className="ri-arrow-right-line text-white text-xl w-5 h-5 flex items-center justify-center"></i>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* 中央メッセージ */}
        <div className="bg-white rounded-3xl p-12 md:p-16 shadow-2xl mb-20 border-2 border-[#FFD700]/30">
          <div className="max-w-4xl mx-auto text-center">
            <div className="flex items-center justify-center mb-8">
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-[#00A58E] to-teal-600 rounded-full">
                <i className="ri-hand-heart-line text-white text-4xl w-10 h-10 flex items-center justify-center"></i>
              </div>
            </div>
            <h3 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              心を込めた実家整理
            </h3>
            <p className="text-xl text-gray-600 leading-relaxed mb-8">
              買い取りかわせみは、単なる買取業者ではございません。<br />
              <strong className="text-[#00A58E]">ご家族の遺産整理のパートナー</strong>として、<br />
              大切な思い出と資産を、次の世代へとつなぐお手伝いをいたします。
            </p>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="flex items-center justify-center gap-2 text-gray-700">
                <i className="ri-check-double-line text-[#00A58E] text-2xl w-6 h-6 flex items-center justify-center"></i>
                <span className="text-lg"><strong>出張費・査定費</strong><br />完全無料</span>
              </div>
              <div className="flex items-center justify-center gap-2 text-gray-700">
                <i className="ri-check-double-line text-[#00A58E] text-2xl w-6 h-6 flex items-center justify-center"></i>
                <span className="text-lg"><strong>即日現金払い</strong><br />可能</span>
              </div>
              <div className="flex items-center justify-center gap-2 text-gray-700">
                <i className="ri-check-double-line text-[#00A58E] text-2xl w-6 h-6 flex items-center justify-center"></i>
                <span className="text-lg"><strong>秘密厳守</strong><br />徹底</span>
              </div>
            </div>
          </div>
        </div>

        {/* 都市部相続世代向けメッセージ */}
        <div className="bg-gradient-to-br from-[#FAF8F3] to-[#FFF8E1] rounded-3xl p-12 md:p-16">
          <h4 className="text-3xl md:text-4xl font-bold text-gray-800 text-center mb-12" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            都心でお忙しいお子様世代へ
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 flex items-center justify-center bg-[#00A58E] rounded-full flex-shrink-0">
                <i className="ri-time-line text-white text-2xl w-7 h-7 flex items-center justify-center"></i>
              </div>
              <div>
                <h5 className="text-xl font-bold text-gray-800 mb-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  遠方で何度も通えない
                </h5>
                <p className="text-gray-600 leading-relaxed">
                  一度のご訪問で、買取・処分・清掃まで完結いたします。お客様の貴重なお時間を大切にいたします。
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 flex items-center justify-center bg-[#FF6B35] rounded-full flex-shrink-0">
                <i className="ri-home-line text-white text-2xl w-7 h-7 flex items-center justify-center"></i>
              </div>
              <div>
                <h5 className="text-xl font-bold text-gray-800 mb-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  大型家具の処分が大変
                </h5>
                <p className="text-gray-600 leading-relaxed">
                  タンス・食器棚・ピアノなど、重くて運べない家具も、すべて私どもが対応いたします。
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 flex items-center justify-center bg-[#7CB342] rounded-full flex-shrink-0">
                <i className="ri-question-line text-white text-2xl w-7 h-7 flex items-center justify-center"></i>
              </div>
              <div>
                <h5 className="text-xl font-bold text-gray-800 mb-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  価値が分からない
                </h5>
                <p className="text-gray-600 leading-relaxed">
                  10年の経験を持つプロの鑑定士が、一点一点丁寧に査定し、その真価を見極めます。
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 flex items-center justify-center bg-[#00A58E] rounded-full flex-shrink-0">
                <i className="ri-team-line text-white text-2xl w-7 h-7 flex items-center justify-center"></i>
              </div>
              <div>
                <h5 className="text-xl font-bold text-gray-800 mb-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  家族への説明が必要
                </h5>
                <p className="text-gray-600 leading-relaxed">
                  詳細な報告書をご提供し、離れて暮らすご家族にも安心してご説明いただけます。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}